/* eslint-disable no-console */

import { register } from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready () {
      console.log(
        'App is being served from cache by a service worker.\n' +
        'For more details, visit https://goo.gl/AFskqB'
      )
    },
    registered () {
      console.log('Service worker has been registered.')
    },
    cached () {
      console.log('Content has been cached for offline use.')
    },
    updatefound (registration) {
      console.log('New content is downloading.')
      // Per evitare l'errore "Uncaught SyntaxError: Unexpected token <"
      // che si presenta in chrome andiamo a fare l'update forzato del
      // service worker quando viene rilevato un nuovo update, per info vedere:
      // https://github.com/quasarframework/quasar/discussions/8751
      // LO LASCIAMO PER ORA ANCHE SE ABBIAMO VISTO FACENDO I TEST CHE NON
      // RISOLVE IL PROBLEMA.
      try {
        registration.update()
        console.log( 'Worker updated' )
      } catch (err) {
        console.err('SW update failed:', err)
      }
    },
    updated () {
      console.log('New content is available; please refresh.')
    },
    offline () {
      console.log('No internet connection found. App is running in offline mode.')
    },
    error (error) {
      console.error('Error during service worker registration:', error)
    }
  })
}
